<template>
  <el-card>
    <el-tabs v-model="activeName">
      <el-tab-pane label="用户列表" name="1">
        <el-row class="mb-15">
          <el-input v-model="ss.name" class="w200 mr-15" placeholder="请输入用户名" clearable></el-input>
          <el-input v-model="ss.phone" class="w200 mr-15" placeholder="请输入手机号" clearable></el-input>
          <el-select v-model="ss.memberType" placeholder="请选择用户角色" class="mr-15" clearable>
            <el-option v-for="item in Object.keys(memberTypeDict)" :key="item" :label="memberTypeDict[item]"
              :value="item">
            </el-option>
          </el-select>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-row>
        <el-table v-loading="tableLoading" :data="tableData" border>
          <el-table-column label="用户名" prop="name" align="center"></el-table-column>
          <el-table-column label="用户角色" prop="memberType" align="center">
            <template slot-scope="scope">
              {{ memberTypeDict[scope.row.memberType] }}
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="phone" align="center"></el-table-column>
          <el-table-column label="服务商名称" prop="serverName" align="center"></el-table-column>
          <el-table-column label="企业名称" prop="enterpriseName" align="center"></el-table-column>
          <el-table-column label="注册时间" prop="createTime" align="center" :formatter="dateFormat"></el-table-column>
          <el-table-column label="操作" width="90" v-if="$checkArr('webUser:rolePageList')">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="modify(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;">
          <el-pagination class="mt-15" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="page.index" :page-sizes="page.sizes" :page-size.sync="page.size"
            layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>

      </el-tab-pane>
      <el-tab-pane :label="formTitle" name="2" v-if="$checkArr('webUser:rolePageList')">
        <el-row>
          <el-col :span="12">
            <el-form ref="form" :model="formData" :rules="{
              // name: [
              //   {
              //     required: true,
              //     message: '该项目不能为空',
              //     trigger: 'blur',
              //   },
              // ]
            }" label-width="150px" label-position="right">
              <el-form-item label="用户名" prop="name">
                <el-input v-model="formData.name" placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone" v-if="operationType === 'add'">
                <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="pwd" v-if="operationType === 'add'">
                <el-input v-model="formData.pwd" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item label="旧密码" prop="oldPwd" v-if="operationType === 'edit'">
                <el-input v-model="formData.oldPwd" placeholder="请输入旧密码"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPwd" v-if="operationType === 'edit'">
                <el-input v-model="formData.newPwd" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="再次输入新密码" prop="confirmPwd" v-if="operationType === 'edit'">
                <el-input v-model="formData.confirmPwd" placeholder="请再次输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button type="success" @click="handleSave">保存
                </el-button>
                <el-button type="info" @click="back()">返回</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { formatDate, dateFormat } from "@/components/js/date";
import { memberTypeDict } from '@/data/constant'

export default {
  mounted() {
    if (this.$checkArr("webUser:rolePageList")) {
      this.userPageList("初始化");
      // this.countryCodeList();
    } else {
      this.$wMsg("无权限");
    }
  },
  data() {
    return {
      tableLoading: false,
      memberTypeDict,
      activeName: "1",
      tableData: [],
      ss: {
        name: "",
        loginName: "",
        memberType: undefined
      },
      page: {
        index: 1,
        sizes: [10, 20, 30, 40],
        size: 10,
        total: 40,
      },
      formData: {},
      formTitle: "添加人员",
      imgServer: "http://tu.yaku.live/",
      dataScopeArr: [],
      operationType: "add" // add 为新增，edit 为编辑
    };
  },
  filters: {
    formatDate(time) {
      time = time
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  methods: {

    handleSearch() {
      this.page.index = 1
      this.userPageList()
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.operationType === 'edit') { // 编辑
            if (this.formData.newPwd === this.formData.confirmPwd) {
              this.$api.roleUpdate({
                id: this.formData.id,
                name: this.formData.name,
                pwd: this.formData.newPwd,
                oldPwd: this.formData.oldPwd,
              }).then(() => {
                this.$sMsg("编辑成功");
                this.back();
                this.$CL();
              })
            } else {
              this.$wMsg('新密码与确认密码不一致！');
            }
          } else {
            // 新增
            this.$api.roleAdd({
              name: this.formData.name,
              pwd: this.formData.pwd,
              phone: this.formData.phone,
              regionCode: '86'
            }).then(() => {
              this.$sMsg("新增成功");
              this.back();
              this.$CL();
            })
          }

        } else {
          this.$wMsg('请正确填写表单！');
        }
      })
      // this.$OL("正在保存...")
    },
    // 格式化表格日期
    dateFormat(row, column) {
      return dateFormat(row, column)
    },
    // 重置formData
    reData() {
      this.formData = {};
    },

    //
    async userPageList() {
      this.tableLoading = true
      const params = {}
      if (this.ss.name) {
        params.name = this.ss.name
      }
      if (this.ss.phone) {
        params.phone = this.ss.phone
      }
      if (this.ss.memberType) {
        params.memberType = Number(this.ss.memberType)
      }
      await this.$api
        .rolePageList({
          form: params,
          pageIndex: this.page.index,
          pageSize: this.page.size,
        })
        .then((res) => {
          this.tableLoading = false
          this.page.total = res.data.data.total;
          this.tableData = res.data.data.list;
        });
    },

    // 修改
    modify(v) {
      let obj = JSON.parse(JSON.stringify(v));
      this.formData = obj;
      this.activeName = "2";
      this.formTitle = "修改人员";
      this.operationType = "edit"
    },


    // 重置密码
    rePwd(v) {
      this.$wTx(
        "该操作将重置用户：" + v.name + "的登录密码，确认继续吗？",
        () => {
          this.$OL("正在重置密码...");
          this.$api.webUserResetPassword({ id: v.id }).then((res) => {
            this.$CL();
            this.$sMsg("密码重置成功");
            this.userPageList();
          });
        },
        () => {
          this.$iMsg("已取消重置密码操作");
        }
      );
    },

    // 删除
    removeAvatar(v) {
      this.$wTx(
        "该操作将删除该用户头像，确认继续吗？",
        () => {
          this.$OL("正在删除中...");
          this.$api
            .deleteAvatar({ id: v })
            .then((res) => {
              this.$sMsg("删除成功");
              this.back();
              this.$CL();
            });
        },
        () => {
          this.$iMsg("已取消删除");
        }
      );
    },

    // 查询国家代码
    countryCodeList() {
      // this.dataScopeArr = CountryCode.country
      this.$api
        .regionList()
        .then((res) => {
          this.dataScopeArr = res.data.data;
        });

    },


    // 返回
    back() {
      this.reData();
      this.activeName = "1";
      this.formTitle = "添加人员";
      this.formData = {};
      this.userPageList();
      this.operationType = "add"
    },

    // 切换页码
    handleCurrentChange(index) {
      this.userPageList();
    },

    // 切换每页条目数
    handleSizeChange(size) {
      this.userPageList();
    },

    // 删除用户
    handleDelete(row) {
      this.$wTx("该操作将永久删除当前条目！", () => {
        this.$OL('正在删除...')
        this.$api.roleDelete({
          id: row.id
        }).then(() => {
          this.back();
          this.$CL();
          this.$sMsg("删除成功");
        })
      }, () => {
        this.$iMsg("已取消删除");
      })
    }
  },
  watch: {
    activeName() {
      if (this.activeName == "1") {
        this.reData();
        this.formTitle = "添加人员";
        this.operationType = "add"
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
